import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';
import {
  types as actions,
  resendVerifyCompletedAction,
  errorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.RESEND_VERIFY),
    switchMap(action =>
      AuthService.resendVerify(action.email).pipe(
        map(() => resendVerifyCompletedAction(action.email)),
        catchError(error => of(errorAction(error)))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/auth/resendVerify.js